export function getAllSettings(state) {
  return state.vodSettings;
}

export function getCurrency(state) {
  return _.get(state, 'vodSettings.currency', 'USD');
}



// WEBPACK FOOTER //
// ./src/shared/selectors/vod-settings.js